const HandleNavigateToLicensingAndAppointmentLink = () => {
    const mswsHost = process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST ? process.env.REACT_APP_MORGAN_STANLEY_MSSWIS_HOST : 'https://ideas-qa07.msdwis.com';
    console.log("Redirecting to 99723");
    var ILTDirectURL = `${mswsHost}/threedweb/3d.html#appid=99723`;
    window.open(ILTDirectURL, '_blank');
}

export default HandleNavigateToLicensingAndAppointmentLink;


// WEBPACK FOOTER //
// ./src/components/Helpers/HandleNavigateToLicensingAndAppointmentLink.js